import {makeAutoObservable, makeObservable, observable} from "mobx";
import axios from "axios";

export default class PlanningActionsStore {
    constructor() {
        this.view = "Lecture";
        this.viewModalFormAction = null; // contient l'id de la tache si modification, et contient création sinon
        this.viewModal = null; // contient l'id de la tache si modification, et contient création sinon
        this.celulle = {colonne_id: null, sousColonne_id: null, ligne_id: null};
        this.idWidget = "";
        this.idPlanning = "";
        this.isLoading = true;
        this.statuts = [];
        this.taches = [];
        this.taches_archivees = [];
        this.taches_boitereception = [];
        this.structure = {lignes: [], colonne: []};
        this._token = null;
        this.planningNotFound = false;
        this.nbBoiteReception = 0;
        this.planningsEntreprise = [];
        // Actions inter-Totems : objet autonome, distinct des PATache du planning.
        this.idTotem = null;
        this.intertotemTargets = [];
        this.intertotemActionsReceived = [];
        this.intertotemActionsSent = [];
        this.intertotemActionSelected = null;
        this.intertotemActionsLoading = false;
        this.showModalFreemium = false;

        // Sprint 2 — Vues calendaires
        this.calViewMode = 'semaine';    // 'jour' | 'semaine' | 'mois'
        this.calCurrentDate = null;      // Date ISO string YYYY-MM-DD
        this.calNewTacheDate = null;     // date pré-remplie lors de l'ajout depuis le calendrier
        this.calendarVersion = 0;        // incrémenté après saveTask pour forcer rechargement du calendrier

        // Sprint 3 — Filtres rapides
        this.filtresActifs = { priorite: null, statut_id: null, responsable_id: null };
        this.membres = [];               // membres du planning (pour filtres)

        // Sprint 4 — Présence temps réel
        this.presenceUsers = [];         // [{ userId, prenom, nom, color }]

        makeAutoObservable(this);

        // makeObservable(this, {
        //     structure: observable,
        // });
    }

    initialize(token, idWidget, idPlanning, view = "Lecture", soft = false) {
        if (soft && this.idPlanning === idPlanning && this._dataLoaded) {
            if (view && view !== "Lecture") this.changeView(view);
            return;
        }
        this._token = token;
        // Store totem and entreprise info for totem list fetch
        this._idTotem = null;
        this._entrepriseCode = null;
        this.idWidget = idWidget;
        this.idPlanning = idPlanning;
        this.idTotem = null;
        this.intertotemTargets = [];
        this.intertotemActionsReceived = [];
        this.intertotemActionsSent = [];
        this.intertotemActionSelected = null;
        this._dataLoaded = false; // Force un rechargement des données
        this.resetViewState();
        this.changeView(view);
    }

    resetViewState() {
        this.view = "Lecture";
        this.viewModalFormAction = null;
        this.viewModal = null;
    }

    async fetchInitialData() {
        // Fonction de pause pour attendre un certain temps
        const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        // Limite de temps pour arrêter la boucle d'attente (en millisecondes)
        const timeout = 10000; // 10 secondes
        const startTime = Date.now();

        // Attendre jusqu'à ce que this.idPlanning soit défini
        while (!this.idPlanning || this.idPlanning === 0) {
            console.warn("idPlanning est vide. Attente de l'initialisation de idPlanning...");
            await wait(100); // Pause de 100ms avant de vérifier à nouveau

            // Vérifier si la limite de temps est atteinte
            if (Date.now() - startTime >= timeout) {
                console.error("Timeout: L'initialisation de idPlanning a pris trop de temps.");
                return; // Sortir de la fonction pour éviter de planter inutilement
            }
        }

        console.log("idPlanning est défini. Récupération des données initiales...");

        await Promise.all([
            this.recupStructurePlanning(),
            this.getPlanningsEntreprise(),
            this.recupStatuts(),
            this.getMembres()
        ]);
        await this.refreshIntertotemActions();
        this._dataLoaded = true; // Données chargées, ne plus recharger au changement de vue
    }

    changeView(view) {
        // On change la vue immédiatement
        this.view = view;
        // fetchInitialData uniquement si les données ne sont pas encore chargées
        // (évite de vider et recharger la boîte de réception à chaque changement de vue)
        if (!this._dataLoaded) {
            this.fetchInitialData().catch(err => console.error('changeView fetch error:', err));
        }
    }

    openModalFormAction(colonne_id, sousColonne_id, ligne_id, tache_id) {
        this.closeModal();
        this.celulle = {colonne_id, sousColonne_id, ligne_id};
        this.viewModalFormAction = tache_id || "création";
    }

    closeModalFormAction() {
        this.celulle = {colonne_id: null, sousColonne_id: null, ligne_id: null};
        this.viewModalFormAction = null;
    }

    openModal(type) {
        this.closeModalFormAction();
        if (type === 'archive') {
            this.recupTaches('archive');
        } else if (type === 'boite reception') {
            // Compatibilité avec les anciens points d'entrée : les échanges
            // inter-Totems sont désormais pilotés dans un espace unique.
            return this.openIntertotemActions();
        }
        this.viewModal = type;
    }

    closeModal() {
        this.viewModal = null;
    }

    async recupStructurePlanning() {
        this.isLoading = true;

        try {
            this.isLoading = true;
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/structurePlanning/${this.idPlanning}`, {
                headers: {"Authorization": `Bearer ${this._token}`}
            });

            if (res.status === 200) {
                this.structure = res.data;
                await this.recupTaches();
            }
        } catch (error) {
            this.handleStructurePlanningError(error);
        } finally {
            this.isLoading = false;
        }
    }


    handleStructurePlanningError(error) {
        if (error.response?.status === 404) {
            const responseData = error.response.data;
            if (responseData.message?.startsWith("No query results for model")) {
                console.error("Le planning n'existe plus :", responseData);
                this.structure = null;
                this.planningNotFound = true;
            } else {
                console.error('Erreur lors du chargement de la structure:', error);
            }
        } else {
            console.error('Erreur lors du chargement de la structure:', error);
        }
    }

    async recupTaches(affichage = 'planning') {
        // this.isLoading = true;
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/listeTaches/${this.idPlanning}?affichage=${affichage}`
                , {headers: {"Authorization": `Bearer ${this._token}`}});
            if (affichage === "planning") {
                this.taches = res.data;
            } else if (affichage === "archive") {
                this.taches_archivees = res.data;
            } else if (affichage === "boite reception") {
                this.taches_boitereception = res.data;
            }
        } catch (error) {
            console.error('Erreur lors du chargement des tâches:', error);
        } finally {
            // this.isLoading = false;
        }
    }

    async recupStatuts() {
        this.isLoading = true;
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/listeStatuts/${this.idPlanning}`
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });

            this.statuts = res.data;
        } catch (error) {
            console.error('Erreur lors du chargement des statuts:', error);
        } finally {
            this.isLoading = false;
        }
    }

    async addLineToDatabase(newLine, ordre) {
        newLine.planning_id = this.idPlanning;
        newLine.ordre = ordre + 1;
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/PA/addLine`
                , newLine
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            await this.fetchLinesFromDatabase();
        } catch (error) {
            console.error('Erreur lors de l\'ajout de la ligne:', error);
        }
    }

    async addColumnToDatabase(newColumn, ordre) {
        newColumn.planning_id = this.idPlanning;
        newColumn.ordre = ordre + 1;
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/PA/addColumn`
                , newColumn
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });

            // Après avoir ajouté la ligne avec succès à la base de données,
            // mettez à jour les lignes affichées en récupérant les données les plus récentes
            await this.fetchColumnsFromDatabase();
        } catch (error) {
            console.error('Erreur lors de l\'ajout de la colonne:', error);
        }
    }

    async addSubColumnToDatabase(newSubColumn, column_id) {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/PA/addSubColumn/${column_id}`
                , newSubColumn
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            await this.fetchColumnsFromDatabase();
        } catch (error) {
            console.error('Erreur lors de l\'ajout de la sous-colonne:', error);
        }
    }

    async deleteLineToDatabase(idLine) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/PA/deleteLine/${idLine}`
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            await this.fetchLinesFromDatabase();
        } catch (error) {
            console.error('Erreur lors de la suppression de la ligne:', error);
        }
    }

    async deleteColumnToDatabase(idColumn) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/PA/deleteColumn/${idColumn}`
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            await this.fetchColumnsFromDatabase();
        } catch (error) {
            console.error('Erreur lors de la suppression de la colonne:', error);
        }
    }

    async deleteSubColumnToDatabase(idSubColumn) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/PA/deleteSubColumn/${idSubColumn}`
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            await this.fetchColumnsFromDatabase();
        } catch (error) {
            console.error('Erreur lors de la suppression de la sous-colonne:', error);
        }
    }

    async dupliquerTache(idTache) {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/PA/dupliquerTache/${idTache}`
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            this.updateLocalTacheDatas(response.data);
            //await this.updateLocalTache(response.data.id, response.data.colonne_id, response.data.sous_colonne_id, response.data.ligne_id);
        } catch (error) {
            console.error('Erreur:', error);
            // Gérer les erreurs ici, par exemple afficher un message à l'utilisateur
        }
    }


    async archiveTacheToLocal(idTache) {
    try {
        // Trouver l'index de la tâche à archiver
        const tacheIndex = this.taches.findIndex(t => String(t.id) === String(idTache));
        if (tacheIndex !== -1) {
            // Si la tâche existe, la déplacer vers les tâches archivées
            const tache = this.taches.splice(tacheIndex, 1)[0];
            this.taches_archivees.push(tache);
        } else {
            console.error('Tâche non trouvée pour archivage:', idTache);
        }
    } catch (error) {
        console.error('Erreur lors de l\'archivage de la tâche :', error);
    }
}

    async archiveTacheToDatabase(idTache) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/PA/archiveTache/${idTache}`
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            // await this.recupTaches();
        } catch (error) {
            console.error('Erreur:', error);
            // Gérer les erreurs ici, par exemple afficher un message à l'utilisateur
        }
    }

    async deleteTacheToDatabase(idTache) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/PA/deleteTache/${idTache}`
                , {
                    headers: {"Authorization": `Bearer ${this._token}`}
                });
            // await this.recupTaches();
        } catch (error) {
            console.error('Erreur:', error);
            // Gérer les erreurs ici, par exemple afficher un message à l'utilisateur
        }
    }

    async fetchLinesFromDatabase() {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/getLignes/${this.idPlanning}`, {
                headers: {"Authorization": `Bearer ${this._token}`}
            });

            // Mettez à jour les lignes affichées dans votre application avec les données récupérées
            this.structure.lignes = res.data;
        } catch (error) {
            console.error('Erreur lors du chargement des lignes:', error);
        }
    }

    async fetchColumnsFromDatabase() {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/getColonnes/${this.idPlanning}`, {
                headers: {"Authorization": `Bearer ${this._token}`}
            });

            // Mettez à jour les lignes affichées dans votre application avec les données récupérées
            this.structure.colonnes = res.data;

        } catch (error) {
            console.error('Erreur lors du chargement des colonnes:', error);
        }
    }

    // Méthode pour mettre à jour l'ordre des lignes dans la base de données
    async updateLineOrderInDatabase(newLines) {
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/api/PA/updateLineOrder`, newLines, {
                headers: {"Authorization": `Bearer ${this._token}`}
            });
            console.log('Ordre des lignes mis à jour avec succès:');
        } catch (error) {
            console.error('Erreur lors de la mise à jour de l\'ordre des lignes:', error);
        }
    }

    // Méthode pour mettre à jour les informations de la colonne via l'API
    async updateColumnData(columnId, libelle, couleur_fond, couleur_txt) {
        // Mettre à jour les données de la colonne dans le store avec les nouvelles valeurs
        const updatedColumns = this.structure.colonnes.map((colonne) => {
            if (colonne.id === columnId) {
                return {
                    ...colonne,
                    libelle: libelle,
                    couleur_fond: couleur_fond,
                    couleur_txt: couleur_txt
                };
            }
            return colonne;
        });

        this.setStructureColonnes(updatedColumns);

        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/PA/updateColumn/${columnId}`, {
                libelle,
                couleur_fond,
                couleur_txt
            }, {headers: {"Authorization": `Bearer ${this._token}`}});
            console.log('Colonne mise à jour avec succès:', res.data);
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la colonne:', error);
        }
    }

    async updateSubColumnData(subColumnId, libelle) {
        // Mettre à jour les données de la sous-colonne dans le store avec les nouvelles valeurs
        const updatedColumns = this.structure.colonnes.map(colonne => {
            const updatedSousColonnes = colonne.sous_colonnes.map(subColonne => {
                if (subColonne.id === subColumnId) {
                    return {
                        ...subColonne,
                        libelle: libelle
                    };
                }
                return subColonne;
            });
            return {
                ...colonne,
                sous_colonnes: updatedSousColonnes
            };
        });

        this.setStructureColonnes(updatedColumns);

        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/PA/updateSubColumn/${subColumnId}`, {
                libelle
            }, {headers: {"Authorization": `Bearer ${this._token}`}});
            console.log('Sous-colonne mise à jour avec succès:', res.data);
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la sous-colonne:', error);
        }
    }


    // Méthode pour mettre à jour les informations de la colonne via l'API
    async updateRowData(rowId, libelle, couleur_fond, couleur_txt) {
        // Mettre à jour les données de la colonne dans le store avec les nouvelles valeurs
        const updatedRows = this.structure.lignes.map((ligne) => {
            if (ligne.id === rowId) {
                return {
                    ...ligne,
                    libelle: libelle,
                    couleur_fond: couleur_fond,
                    couleur_txt: couleur_txt
                };
            }
            return ligne;
        });

        this.structure.lignes = updatedRows;

        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/PA/updateLigne/${rowId}`, {
                libelle,
                couleur_fond,
                couleur_txt
            }, {headers: {"Authorization": `Bearer ${this._token}`}});
            console.log('Ligne mise à jour avec succès:', res.data);
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la ligne:', error);
        }
    }


    async saveTask(taskData) {
        try {
            const response = taskData.id ?
                await axios.put(`${process.env.REACT_APP_API_URL}/api/PA/updateTache/${taskData.id}`, taskData, {headers: {"Authorization": `Bearer ${this._token}`}}) :
                await axios.post(`${process.env.REACT_APP_API_URL}/api/PA/addTache/${this.idPlanning}`, taskData, {headers: {"Authorization": `Bearer ${this._token}`}});

            console.log(taskData.id ? 'Tâche mise à jour avec succès :' : 'Tâche créée avec succès :', response.data);
            // this.recupTaches();
            this.updateLocalTacheDatas(response.data);
            // Forcer le rechargement du calendrier (la date_estimee a pu changer)
            this.calendarVersion += 1;
            return response.data;
        } catch (error) {
            console.error(taskData.id ? 'Erreur lors de la modification de la tâche :' : 'Erreur lors de la création de la tâche :', error);
            throw error; // Propager l'erreur pour la gérer dans le composant
        }
    }

    async updateLocalTacheDatas(taskData) {
        // Trouver la tâche et la mettre à jour
        const tacheIndex = this.taches.findIndex(t => String(t.id) === String(taskData?.id));

        if (tacheIndex !== -1) {
            this.taches[tacheIndex] = {
                ...this.taches[tacheIndex],
                ...taskData
            }

        } else {
            // this.recupTaches();
            // Ajouter la nouvelle tâche directement à this.taches
            this.taches.push(taskData);
        }
    }

    taskUpdatePayload(tache, updates = {}) {
        if (!tache?.id) throw new Error('Action introuvable.');

        return {
            id: tache.id,
            titre: tache.titre || '',
            description: tache.description || '',
            date_estimee: tache.date_estimee || null,
            date_debut: tache.date_debut || null,
            priorite: tache.priorite ?? 2,
            responsable_id: tache.responsable_id || null,
            statut_id: tache.statut?.id || null,
            pourcentage: tache.pourcentage ?? 0,
            colonne_id: tache.colonne_id || null,
            sous_colonne_id: tache.sous_colonne_id || null,
            ligne_id: tache.ligne_id || null,
            affichage: tache.affichage || 'planning',
            ...updates,
        };
    }

    async updateStatutTache(tacheId, statutId) {
        const tache = this.taches.find(task => String(task.id) === String(tacheId));
        const previous = tache ? { ...tache } : null;

        if (tache) await this.updateLocalTacheStatut(tacheId, statutId);

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/api/PA/changeStatut/${tacheId}`,
                { statut_id: statutId },
                { headers: { Authorization: `Bearer ${this._token}` } }
            );
            if (response.data?.id) await this.updateLocalTacheDatas(response.data);
            return response.data;
        } catch (error) {
            if (previous) await this.updateLocalTacheDatas(previous);
            throw error;
        }
    }

    async updateTaskProgress(tacheId, pourcentage) {
        const tache = this.taches.find(task => String(task.id) === String(tacheId));
        const value = Math.max(0, Math.min(100, Number(pourcentage) || 0));
        return this.saveTask(this.taskUpdatePayload(tache, { pourcentage: value }));
    }

    async moveTache(TacheId, CelluleId) {
        try {
            // Séparez celluleId en colonneId, sousColonneId et ligneId
            const [colonneId, sousColonneId, ligneId] = CelluleId.split('#');

            // Mettre à jour localement l'état des tâches
            await this.updateLocalTache(TacheId, colonneId, sousColonneId, ligneId);

            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/PA/moveTache/${TacheId}`
                , {colonne_id: colonneId, sous_colonne_id: sousColonneId, ligne_id: ligneId}
                , {headers: {"Authorization": `Bearer ${this._token}`}}
            );

            console.log('Tâche déplacée avec succès');
            //this.recupTaches();
        } catch (error) {
            console.error('Erreur lors de la modification de la tâche :', error);
            throw error; // Propager l'erreur pour la gérer dans le composant
        }
    }

    async moveTacheKanban(TacheId, StatutId) {
        try {
            // Mettre à jour localement l'état des tâches
            await this.updateLocalTacheStatut(TacheId, StatutId);

            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/PA/changeStatut/${TacheId}`
                , {statut_id: StatutId}
                , {headers: {"Authorization": `Bearer ${this._token}`}}
            );

            console.log('Tâche déplacée avec succès');
        } catch (error) {
            console.error('Erreur lors de la modification de la tâche sur le planning Kanban :', error);
            throw error; // Propager l'erreur pour la gérer dans le composant
        }
    }


    async updateLocalTacheStatut(TacheId, StatutId) {
        // Trouver la tâche et mettre à jour son statut
        const tacheIndex = this.taches.findIndex(t => String(t.id) === String(TacheId));
        const statut = StatutId ? this.statuts.find(s => String(s.id) === String(StatutId)) : null;

        if (tacheIndex !== -1) {
            this.taches[tacheIndex] = {
                ...this.taches[tacheIndex],
                statut: statut ? {
                    id: statut.id,
                    couleur: statut.couleur,
                    icone: statut.icone,
                    libelle: statut.libelle
                } : {id: null, couleur: null, icone: null, libelle: null}
            };
        }
    }


    // PEP :: Fonction pour supprimer une tâche localement
    // Appeler par le webSocket apres une suppression d'une tache
    // Pour eviter le rechargement du composant
    async deleteLocalTache(TacheId) {
        try {
            // Trouver l'index de la tâche à supprimer
            const tacheIndex = this.taches.findIndex(t => String(t.id) === String(TacheId));
            if (tacheIndex !== -1) {
                // Si la tâche existe, la supprimer
                this.taches.splice(tacheIndex, 1);
            } else {
                console.error('Tâche non trouvée pour suppression:', TacheId);
            }
        } catch (error) {
            console.error('Erreur lors de la suppression de la tâche :', error);
        }
    }

    async updateLocalTache(TacheId, colonneId, sousColonneId, ligneId) {
        try {
            // Trouver la tâche et mettre à jour ses coordonnées
            const tacheIndex = this.taches.findIndex(t => String(t.id) === String(TacheId));
            if (tacheIndex !== -1) {
                // Si la tâche existe, la mettre à jour
                this.taches[tacheIndex] = {
                    ...this.taches[tacheIndex],
                    colonne_id: colonneId,
                    sous_colonne_id: (sousColonneId === "null") ? null : sousColonneId,
                    ligne_id: ligneId
                };
            } else {
                // Sinon, récupérer la tâche et la mettre à jour
                const newTache = await this.fetchTacheById(TacheId);
                // Mettre à jour les coordonnées de la nouvelle tâche récupérée
                newTache.colonne_id = colonneId;
                newTache.sous_colonne_id = (sousColonneId === "null") ? null : sousColonneId;
                newTache.ligne_id = ligneId;
                this.taches.push(newTache);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération ou mise à jour de la tâche :', error);
        }
    }

    async fetchTacheById(tacheId) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/PA/tache/${tacheId}`,
                {headers: {"Authorization": `Bearer ${this._token}`}}
            );
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération de la tâche :', error);
            throw error;
        }
    }


    // Méthode pour mettre à jour la structure des colonnes
    setStructureColonnes(newColumns) {
        // Mettre à jour la variable structure.colonnes
        this.structure.colonnes = newColumns;
        newColumns.forEach((colonne, index) => {
            colonne.ordre = index + 1;
        });
        this.updateColumnOrderInDatabase(newColumns);
    }

    // Méthode pour mettre à jour l'ordre des colonnes dans la base de données
    async updateColumnOrderInDatabase(newColumns) {
        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/PA/updateColumnOrder`, newColumns, {
                headers: {"Authorization": `Bearer ${this._token}`}
            });
            console.log('Ordre des colonnes mis à jour avec succès:', res.data);
        } catch (error) {
            console.error('Erreur lors de la mise à jour de l\'ordre des colonnes:', error);
        }
    }

    // Méthode pour mettre à jour la structure des lignes
    async setStructureLignes(newLines) {
        // Mettre à jour la variable structure.lignes
        this.structure.lignes = newLines;
        console.log("newLines", newLines);
        console.log("this.structure.lignes", this.structure.lignes);

        newLines.forEach((ligne, index) => {
            ligne.ordre = index + 1;
        });

        // Appelez votre méthode d'API pour mettre à jour les informations dans la base de données
        await this.updateLineOrderInDatabase(newLines);
    }

    async getNbBoiteReception() {
        this.nbBoiteReception = 0;

        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/getNbBoiteReception/${this.idPlanning}`, {
                headers: {"Authorization": `Bearer ${this._token}`}
            });
            this.nbBoiteReception = res.data;
        } catch (error) {
            console.log('error getnbreception')
        }
    }

    async getMembres() {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/membres/${this.idPlanning}`, {
                headers: this.apiHeaders()
            });
            this.membres = res.data?.membres || [];
        } catch (error) {
            console.error('Erreur chargement membres Planning:', error);
            this.membres = [];
        }
    }

    async getPlanningsEntreprise() {
        try {
            // Récupère les plannings de l'entreprise (pas les totems)
            const res = await axios.get(process.env.REACT_APP_API_URL + '/api/PA/plannings', {
                headers: {
                    Authorization: 'Bearer ' + this._token,
                }
            });
            const plannings = Array.isArray(res.data) ? res.data : [];
            const planningCourant = plannings.find(p => String(p.id) === String(this.idPlanning));
            this.idTotem = planningCourant?.totem_id || null;
            this.planningsEntreprise = plannings
                .filter(p => String(p.id) !== String(this.idPlanning))
                .map(p => ({ id: p.id, nom: p.nomTotem || p.nom || 'Planning ' + p.id }));
        } catch (e) {
            console.log('error getPlanningsEntreprise', e);
        }
    }

    async envoyerTacheVersAutrePlanning(planningId, tacheId) {
        try {
            await axios.get(`${process.env.REACT_APP_API_URL}/api/PA/envoyerTacheVersAutrePlanning/${planningId}/${tacheId}`, {
                headers: {"Authorization": `Bearer ${this._token}`}
            });
            // PEP :: Remplacement de recupTached par deleteLocalTache
            // -> pour éviter le rerender du composant à l'appel de la fonction
            // await this.recupTaches();
            await this.deleteLocalTache(tacheId);
            await this.getNbBoiteReception();
        } catch (error) {
            console.log('error envoyerTacheVersAutrePlanning')
        }
    }

    // ─── Actions inter-Totems ────────────────────────────────────────────────

    apiHeaders(extra = {}) {
        return { Authorization: `Bearer ${this._token}`, ...extra };
    }

    intertotemActorHeaders(extra = {}) {
        const readCookie = (name) => (typeof document === 'undefined'
            ? null
            : document.cookie
                .split(';')
                .map(cookie => cookie.trim())
                .find(cookie => cookie.startsWith(`${name}=`))
                ?.slice(name.length + 1));

        // Les parcours OTP stockent le jeton utilisateur sous current_apiToken.
        // user_apiToken reste accepté pour les sessions historiques.
        const userToken = readCookie('current_apiToken') || readCookie('user_apiToken');

        if (!userToken) {
            throw new Error('Votre session utilisateur a expiré. Reconnectez-vous pour agir sur une action inter-Totems.');
        }

        return { Authorization: `Bearer ${userToken}`, ...extra };
    }

    idempotencyKey(prefix = 'intertotem') {
        const unique = typeof crypto !== 'undefined' && crypto.randomUUID
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        return `${prefix}-${unique}`;
    }

    async refreshIntertotemActions() {
        if (!this.idTotem) {
            this.intertotemTargets = [];
            this.intertotemActionsReceived = [];
            this.intertotemActionsSent = [];
            return;
        }

        this.intertotemActionsLoading = true;
        try {
            const [targets, received, sent] = await Promise.allSettled([
                axios.get(`${process.env.REACT_APP_API_URL}/api/intertotem-actions/targets/${this.idTotem}`, { headers: this.intertotemActorHeaders() }),
                axios.get(`${process.env.REACT_APP_API_URL}/api/intertotem-actions/received/${this.idTotem}`, { headers: this.intertotemActorHeaders() }),
                axios.get(`${process.env.REACT_APP_API_URL}/api/intertotem-actions/sent/${this.idTotem}`, { headers: this.intertotemActorHeaders() }),
            ]);
            if (targets.status === 'fulfilled') this.intertotemTargets = targets.value.data?.data || [];
            if (received.status === 'fulfilled') this.intertotemActionsReceived = received.value.data?.data || [];
            if (sent.status === 'fulfilled') this.intertotemActionsSent = sent.value.data?.data || [];

            const failedRequest = [targets, received, sent].find(result => result.status === 'rejected');
            if (failedRequest) throw failedRequest.reason;
        } catch (error) {
            console.error('Erreur chargement actions inter-Totems:', error);
        } finally {
            this.intertotemActionsLoading = false;
        }
    }

    async openIntertotemActions() {
        await this.refreshIntertotemActions();
        this.openModal('intertotem actions');
    }

    async envoyerTacheVersTotem(totemId, tache) {
        if (!this.idTotem) {
            throw new Error('Le Totem source de ce planning est introuvable.');
        }

        const payload = {
            source_totem_id: this.idTotem,
            destination_totem_id: totemId,
            source_module: 'planning_actions',
            source_reference_type: 'pa_tache',
            source_reference_id: tache.id,
            source_context: { planning_id: this.idPlanning, task_title: tache.titre },
            title: tache.titre,
            description: tache.description || null,
            priority: tache.priorite ?? 2,
            due_date: tache.date_estimee || null,
            status: 'envoyee',
        };

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/intertotem-actions`,
            payload,
            { headers: this.intertotemActorHeaders({ 'Idempotency-Key': this.idempotencyKey('send') }) }
        );
        await Promise.all([
            this.recupStructurePlanning(),
            this.recupTaches(),
            this.refreshIntertotemActions(),
        ]);
        return response.data?.data;
    }

    async ouvrirActionIntertotem(actionId) {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/intertotem-actions/${actionId}`, {
            headers: this.intertotemActorHeaders({ 'X-Totem-Id': this.idTotem || '' })
        });
        const timeline = await axios.get(`${process.env.REACT_APP_API_URL}/api/intertotem-actions/${actionId}/timeline`, {
            headers: this.intertotemActorHeaders()
        });
        this.intertotemActionSelected = {
            ...(response.data?.data || {}),
            events: timeline.data?.data || [],
        };
        await this.refreshIntertotemActions();
        return this.intertotemActionSelected;
    }

    async transitionActionIntertotem(actionId, status, comment = null, version = null) {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/intertotem-actions/${actionId}/transition`,
            { status, comment, version },
            { headers: this.intertotemActorHeaders({ 'Idempotency-Key': this.idempotencyKey('transition') }) }
        );
        this.intertotemActionSelected = response.data?.data || this.intertotemActionSelected;
        await this.refreshIntertotemActions();
        return this.intertotemActionSelected;
    }

    async planifierActionIntertotem(actionId, comment = null) {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/intertotem-actions/${actionId}/plan`,
            { local_planning_id: this.idPlanning, comment },
            { headers: this.intertotemActorHeaders({ 'Idempotency-Key': this.idempotencyKey('plan') }) }
        );
        this.intertotemActionSelected = response.data?.data || this.intertotemActionSelected;
        await Promise.all([
            this.recupTaches(),
            this.refreshIntertotemActions(),
        ]);
        return this.intertotemActionSelected;
    }

    ouvrirTacheLocaleIntertotem() {
        const task = this.intertotemActionSelected?.local_task;
        if (!task?.id) return;

        this.closeModal();
        this.changeView('Kanban');
        this.openModalFormAction(null, null, null, task.id);
    }

    async assignerActionIntertotem(actionId, assignedToUserId, comment = null) {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/intertotem-actions/${actionId}/assign`,
            { assigned_to_user_id: assignedToUserId || null, comment },
            { headers: this.intertotemActorHeaders({ 'Idempotency-Key': this.idempotencyKey('assign') }) }
        );
        this.intertotemActionSelected = response.data?.data || this.intertotemActionSelected;
        await this.refreshIntertotemActions();
        return this.intertotemActionSelected;
    }

    async relancerActionIntertotem(actionId, comment = null) {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/intertotem-actions/${actionId}/remind`,
            { comment },
            { headers: this.intertotemActorHeaders({ 'Idempotency-Key': this.idempotencyKey('remind') }) }
        );
        this.intertotemActionSelected = response.data?.data || this.intertotemActionSelected;
        await this.refreshIntertotemActions();
        return this.intertotemActionSelected;
    }

    async ajouterSuiviActionIntertotem(actionId, comment) {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/intertotem-actions/${actionId}/follow-up`,
            { comment },
            { headers: this.intertotemActorHeaders({ 'Idempotency-Key': this.idempotencyKey('follow-up') }) }
        );
        this.intertotemActionSelected = response.data?.data || this.intertotemActionSelected;
        await this.refreshIntertotemActions();
        return this.intertotemActionSelected;
    }

    /**
     * Accepter une tâche de la boîte de réception dans une colonne Kanban.
     * Appelé lors du drop HTML5 natif d'une tâche de réception sur une colonne Kanban.
     */
    async renommerPlanning(nouveauNom) {
        try {
            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/PA/saveParametrage/${this.idPlanning}`,
                {
                    nomPlanning: nouveauNom,
                    statuts: this.statuts.map(s => ({ id: s.id, libelle: s.libelle, couleur: s.couleur, icone: s.icone })),
                },
                { headers: { "Authorization": `Bearer ${this._token}` } }
            );
            if (this.structure) {
                this.structure = { ...this.structure, nom: nouveauNom };
            }
        } catch (error) {
            console.error('Erreur renommerPlanning:', error);
            throw error;
        }
    }

    async accepterTacheReception(tacheId, statutId) {
        try {
            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/PA/changeStatut/${tacheId}`,
                { statut_id: statutId, planning_id: this.idPlanning },
                { headers: { "Authorization": `Bearer ${this._token}` } }
            );
            // Mise à jour optimiste immédiate
            const tache = this.taches_boitereception.find(t => String(t.id) === String(tacheId));
            this.taches_boitereception = this.taches_boitereception.filter(t => String(t.id) !== String(tacheId));
            this.nbBoiteReception = this.taches_boitereception.length;
            if (tache) {
                const statut = this.statuts.find(s => String(s.id) === String(statutId));
                const tacheMaj = {
                    ...tache,
                    affichage: 'planning',
                    statut: statut ? { id: statut.id, couleur: statut.couleur, icone: statut.icone, libelle: statut.libelle } : null
                };
                this.taches = [...this.taches, tacheMaj];
            }
            // Resynchronisation depuis la BDD pour garantir la cohérence
            await Promise.all([
                this.recupTaches('planning'),
                this.recupTaches('boite reception'),
            ]);
        } catch (error) {
            console.error('Erreur accepterTacheReception:', error);
        }
    }

    /**
     * Drag & drop depuis boîte de réception → calendrier.
     * Planifie la tâche à la date cible (date_estimee) et change affichage → 'planning'.
     */
    async accepterTacheReceptionVersCalendrier(tacheId, newDateYMD) {
        try {
            const tache = this.taches_boitereception.find(t => String(t.id) === String(tacheId));
            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/PA/updateTache/${tacheId}`,
                {
                    titre:          tache?.titre || '',
                    date_estimee:   newDateYMD,
                    date_debut:     tache?.date_debut || null,
                    priorite:       tache?.priorite ?? 2,
                    pourcentage:    tache?.pourcentage ?? 0,
                    responsable_id: tache?.responsable?.id || null,
                    statut_id:      tache?.statut?.id || null,
                    colonne_id:     tache?.colonne_id || null,
                    sous_colonne_id:tache?.sous_colonne_id || null,
                    ligne_id:       tache?.ligne_id || null,
                    affichage:      'planning',
                },
                { headers: { "Authorization": `Bearer ${this._token}` } }
            );
            this.taches_boitereception = this.taches_boitereception.filter(t => String(t.id) !== String(tacheId));
            this.nbBoiteReception = this.taches_boitereception.length;
            if (tache) {
                const tacheMaj = { ...tache, date_estimee: newDateYMD, affichage: 'planning' };
                this.taches = [...this.taches, tacheMaj];
            }
            // Resynchronisation depuis la BDD pour garantir la cohérence
            await Promise.all([
                this.recupTaches('planning'),
                this.recupTaches('boite reception'),
            ]);
        } catch (error) {
            console.error('Erreur accepterTacheReceptionVersCalendrier:', error);
            throw error;
        }
    }
}
